import Layout from '../../components/ui/Layout';
import Card from '../../components/ui/Card';
import { IconShield } from '@tabler/icons-react';
import { useTranslation } from '../../i18n/LanguageContext';

const ROLES = [
  {
    role: 'org_admin',
    labelKey: 'role.admin',
    descriptionKey: 'set.role_admin_full',
    permissionKeys: ['set.perm_all_machines', 'set.perm_all_staff', 'set.perm_all_settings', 'nav.billing', 'set.audit_log', 'set.perm_announcements', 'set.perm_emergencies'],
  },
  {
    role: 'manager',
    labelKey: 'role.manager',
    descriptionKey: 'set.role_manager_full',
    permissionKeys: ['set.perm_site_machines', 'set.perm_site_staff', 'set.perm_checks_defects', 'upsell.derv_title', 'set.perm_shifts', 'set.reports'],
  },
  {
    role: 'operator',
    labelKey: 'role.operator',
    descriptionKey: 'set.role_operator_full',
    permissionKeys: ['set.perm_daily_checks_app', 'set.perm_fuel_fills_app', 'set.perm_defect_app', 'set.perm_near_miss_app', 'set.perm_own_quals', 'set.perm_sos'],
  },
];

export default function Roles() {
  const { t } = useTranslation();
  return (
    <Layout>
      <div style={{ padding: 'var(--main-padding)', maxWidth: 680, margin: '0 auto' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 24 }}>
          <IconShield size={20} color="var(--color-text-secondary)" stroke={1.5} />
          <h1 style={{ fontSize: 22, fontWeight: 400 }}>{t('set.roles_title')}</h1>
        </div>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
          {ROLES.map(r => (
            <Card key={r.role}>
              <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 10 }}>
                <span style={{
                  fontSize: 11, padding: '2px 10px', borderRadius: 20,
                  background: r.role === 'org_admin' ? 'var(--color-brand-light)' : r.role === 'manager' ? '#E6F1FB' : 'var(--color-bg-secondary)',
                  color: r.role === 'org_admin' ? 'var(--color-brand)' : r.role === 'manager' ? '#185FA5' : 'var(--color-text-secondary)',
                }}>
                  {t(r.labelKey)}
                </span>
              </div>
              <div style={{ fontSize: 13, color: 'var(--color-text-secondary)', lineHeight: 1.6, marginBottom: 12 }}>
                {t(r.descriptionKey)}
              </div>
              <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap' }}>
                {r.permissionKeys.map(p => (
                  <span key={p} style={{ fontSize: 11, padding: '3px 10px', borderRadius: 20, background: 'var(--color-bg-secondary)', color: 'var(--color-text-secondary)', border: '0.5px solid var(--color-border-light)' }}>
                    {t(p)}
                  </span>
                ))}
              </div>
            </Card>
          ))}
        </div>
      </div>
    </Layout>
  );
}